import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
import ReCAPTCHA from 'react-google-recaptcha';
export default class Aadhaarcollection extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = {
      textexpanded: false,
      aadharNumber: ["", "", ""], // for the 3 parts
      showAadhaar: false,
      checkboxChecked: false,
      checkboxTwo: false,
      checkboxThree: false,
      checkboxFour: false,
      checkboxFive: false,
      checkboxSix: false,
      checkboxSeven: false,
      isSubmitting: false,
      captchaToken: null,
      authenticationtype: "aadharotp",
      
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
       case "warning":
      toast.warning(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.success(msg);
    }
  };
  toggleReadMore = () => {
    this.setState((prevState) => ({ textexpanded: !prevState.textexpanded }));
  };
  handleaadhaarchange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aadharNumber: fieldValue });
  };
 
  
  validateVerhoeff(num) {
    const d = [
      [0,1,2,3,4,5,6,7,8,9],
      [1,2,3,4,0,6,7,8,9,5],
      [2,3,4,0,1,7,8,9,5,6],
      [3,4,0,1,2,8,9,5,6,7],
      [4,0,1,2,3,9,5,6,7,8],
      [5,9,8,7,6,0,4,3,2,1],
      [6,5,9,8,7,1,0,4,3,2],
      [7,6,5,9,8,2,1,0,4,3],
      [8,7,6,5,9,3,2,1,0,4],
      [9,8,7,6,5,4,3,2,1,0]
    ];
  
    const p = [
      [0,1,2,3,4,5,6,7,8,9],
      [1,5,7,6,2,8,3,0,9,4],
      [5,8,0,3,7,9,6,1,4,2],
      [8,9,1,6,0,4,3,5,2,7],
      [9,4,5,3,1,2,6,8,7,0],
      [4,2,8,6,5,7,9,3,0,1],
      [2,7,9,3,8,0,6,4,1,5],
      [7,0,4,6,9,1,3,2,5,8]
    ];
    let c = 0;
    const reversed = num.split("").reverse();
    for (let i = 0; i < reversed.length; i++) {
      c = d[c][p[i % 8][parseInt(reversed[i], 10)]];
    }
    return c === 0;
  }
  ValidAadhaarFormat(aadhaar) {
    return /^[2-9]{1}[0-9]{11}$/.test(aadhaar);
  }
  
  // Aadhaar validation
   isValidAadhaar(aadhaar, useVerhoeff = false) {
    const regex = /^[2-9]{1}[0-9]{11}$/; // 12 digits, starts with 2–9
    if (!regex.test(aadhaar)) return false;
    return useVerhoeff ? this.validateVerhoeff(aadhaar) : true;
    
  }



  HandleSubmit = (e) => {
    e.preventDefault();
  
    const { captchaToken, aadharNumber } = this.state;
    const fullAadhaar = aadharNumber.join("");
  
    if (!this.isValidAadhaar(fullAadhaar.trim())) {
      this.showToast("Invalid Aadhaar Number.", "error");
      return;
    }
  
    if (!captchaToken) {
      this.showToast("Please verify that you are not a robot!", "error");
      return;
    }
  
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("aadharNumber", fullAadhaar);
    formData.append("captchaToken", captchaToken);
  
    fetch(configData.api_url + "C_Abhaaadhar/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          sessionStorage.setItem("requestId", data.requestId);
          sessionStorage.setItem("message", data.details.message);
  
          // ✅ Navigate only for success
          window.location.href = "/aadhaarcollectionotp";
        } else if (data.status === "error") {
          this.showToast(data.message, "error");
  
          // ✅ Navigate conditionally based on backend message
          if (data.message.includes("Login ID is invalid")) {
            // stay on same page or reload
            // window.location.href = "/consentcollectionaadhaar"; // uncomment if needed
          } else {
            // fallback navigation for other errors
            setTimeout(() => {
              window.location.href = "/consentcollectionaadhaar";
            }, 7000);
          }
        }
  
        this.setState({
          aadhaarNumber: "",
          isSubmitting: false,
        });
  
        if (this.recaptchaRef && this.recaptchaRef.current) {
          this.recaptchaRef.current.reset();
        }
      })
    
  };
  
  // HandleSubmit = (e) => {
  //   e.preventDefault();

  
  //   const { captchaToken, aadharNumber } = this.state;
  //   const fullAadhaar = aadharNumber.join("");

  //   if(!this.isValidAadhaar(fullAadhaar.trim()) ){
  //     this.showToast("Invalid Aadhaar Number.", "error");
  //     return;
  //   }

  //   if (!captchaToken) {
  //     this.showToast("Please verify that you are not a robot!", "error");
  //     return;
  //   }
  
  //   // ✅ If Aadhaar passes all UI validations, then call API
  //   this.setState({ isSubmitting: true });
  //   var formData = new FormData();
  //   formData.append("aadharNumber", fullAadhaar);
  //   formData.append("captchaToken", captchaToken);
  
  //   fetch(configData.api_url + "C_Abhaaadhar/add", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         this.showToast(data.message, data.status);
  //         window.location.href = "/aadhaarcollectionotp";
  //         sessionStorage.setItem("requestId", data.requestId);
  //         sessionStorage.setItem("message", data.details.message);
  //       } 
       
  //       else {
  //         this.showToast(
            
  //           "The Aadhaar number you have entered does not match with any of the records. Please enter a different number",
  //           "error"
  //         );
  
  //         setTimeout(() => {
  //           window.location.href = "/consentcollectionaadhaar";
  //         }, 7000);
  //       }
  
  //       this.setState({
  //         aadhaarNumber: "",
  //         isSubmitting: false,
  //       });
  
  //       if (this.recaptchaRef && this.recaptchaRef.current) {
  //         this.recaptchaRef.current.reset();
  //       }
  //     });
  // };
  
  // HandleSubmit = (e) => {
  //   e.preventDefault();

  //   const {
  //     captchaToken,
  //     aadharNumber,
  //     // checkboxChecked,
  //     // checkboxTwo,
  //     // checkboxThree,
  //     // checkboxFour,
  //     // checkboxFive,
  //     // checkboxSix,
  //     // checkboxSeven,
  //     //authenticationtype,
  //     // consentName,
  //   } = this.state;
  //   const fullAadhaar = aadharNumber.join("");
  //   if (fullAadhaar.trim() === "") {
  //     this.showToast("Aadhaar number is required.", "error");
  //     return;
  //   }
  //   const aadhaarRegex = /^\d{12}$/;
  //   if (!aadhaarRegex.test(fullAadhaar)) {
  //     this.showToast(
  //       "Aadhaar must be 12 digits long and contain only numbers.",
  //       "error"
  //     );
  //     return;
  //   } 
  //   if (!captchaToken) {
  //      this.showToast('Please verify that you are not a robot!',"error");
  //     return;
  //   }
    

  //   this.setState({ isSubmitting: true });
  //   var formData = new FormData();
  //   formData.append("aadharNumber", fullAadhaar);
  //   formData.append("captchaToken", captchaToken);
  //   fetch(configData.api_url + "C_Abhaaadhar/add", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         this.showToast(data.message, data.status);
  //         //  window.location.href = "/aadhaarcollectionotp ";
  //         sessionStorage.setItem("requestId", data.requestId);
  //         sessionStorage.setItem("message", data.details.message);
  //       }   else {
  //         // Show message and redirect after 5 sec
  //         this.showToast(data.message,
  //           // "Login ID is invalid or Aadhaar number is incorrect. Please check or change the Aadhaar number..",
  //           "error"
  //         ); 
  
  //         setTimeout(() => {
  //         //   window.location.href = "/consentcollectionaadhaar";
  //         }, 5000);
  //       }
      
  //       this.setState({
  //         aadhaarNumber: "",
  //         isSubmitting: false,
  //       });
      
  //       if (this.recaptchaRef && this.recaptchaRef.current) {
  //         this.recaptchaRef.current.reset();
  //       }
  //     });
  // };
  
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handleAadhaarPartChange = (index, value) => {
    const cleanValue = value.replace(/\D/g, "").slice(0, 4); // Only digits, max 4
    const updated = [...this.state.aadharNumber];
    updated[index] = cleanValue;
    this.setState({ aadharNumber: updated }, () => {
      if (
        cleanValue.length === 4 &&
        index < this.state.aadharNumber.length - 1
      ) {
        const nextInput = document.getElementById(`aadharNumber-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    });
  };
  handleKeyDownAadharNumber = (idx, e) => {
    if (e.key === "Backspace" && !this.state.aadharNumber[idx] && idx > 0) {
      document.getElementById(`aadharNumber-${idx - 1}`).focus();
    }
  };
  toggleAadhaarVisibility = () => {
    this.setState({ showAadhaar: !this.state.showAadhaar });
  };
  handleAuthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ authenticationtype: fieldValue });
  };
  handleBack =()=>{
    window.location="./abharegister"
  }
  render() {
    return (
      <div>
        

        <div className="row justify-content-md-center text-center consentCollectionAadhaar">
          <div className="col-md-6 mt-4">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form>
                <Form.Group>
                  <Form.Label>
                    <b>Enter Your Aadhaar Number</b>
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {this.state.aadharNumber.map((val, idx) => (
                      <Form.Control
                        id={`aadharNumber-${idx}`}
                        className="formselect"
                        style={{
                          textAlign: "center",
                        }}
                        type={this.state.showAadhaar ? "text" : "password"}
                        maxLength={4}
                        value={val}
                        onChange={(e) =>
                          this.handleAadhaarPartChange(idx, e.target.value)
                        }
                        tabIdx={idx + 1}
                        onKeyDown={(e) =>
                          this.handleKeyDownAadharNumber(idx, e)
                        }
                      />
                    ))}
                    <Button
                      variant="outline-secondary"
                      style={{
                        width: "50px",
                        height: "36px",
                        fontSize: "16px",
                      }}
                      className={`rounded-0 bi ${
                        this.state.showAadhaar ? "bi-eye-slash" : "bi-eye"
                      }`}
                      onClick={() =>
                        this.setState({ showAadhaar: !this.state.showAadhaar })
                      }
                    />
                  </div>

                        
                <div className="d-flex">   <ReCAPTCHA 
                    className="mt-4"
                    ref={this.recaptchaRef} 
                    sitekey= {configData.captchaKey}
                    onChange={this.handleCaptchaChange}
                  /> 
                  <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
                  onClick={() => this.recaptchaRef.current.reset()}/>
                  </div>
                </Form.Group>
             </Form>
            </div>
          </div>
        </div>
      
       
        <div className="row  widget_BG widget_BG_grid m-0 mt-3">
        <div className="col text-start">
        
        <Button className="rounded-0 m-1 " variant="warning"
        onClick={this.handleBack}>
          Back
        </Button>
        </div>
          <div className="col text-end">
        
           
            <Button
              className="rounded-0 m-1"
              disabled={this.state.isSubmitting}
              onClick={this.HandleSubmit}
            >
              {this.state.isSubmitting ? "Submitting...Please Wait" : "Next"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
